(ns machtfit.search
  (:require [clojure.string :as str]))

(defn search [{:keys [items query attribute-fn] :or {attribute-fn identity}}]
  (if (str/blank? query)
    items
    (let [words (-> query str/lower-case (str/split #" "))
          match? (fn [item]
                   (let [candidate (-> item attribute-fn str str/lower-case)]
                     (every? #(str/includes? candidate %) words)))]
      (filter match? items))))
